import { cloneElement, isValidElement, ReactNode, useId } from "react";

import { Input } from "@buildpy/ui/input";
import { SimpleSelect } from "@buildpy/ui/select";
import { Textarea } from "@buildpy/ui/textarea";
import { cn } from "@/lib/utils";

// id 를 칸까지 넘기는 것만 — 모르는 컴포넌트(Controller 등)에 htmlFor 를 달면 id 가 칸에 안 닿아 감싸기 연결마저 끊긴다.
const LINKABLE: unknown[] = ["input", "select", "textarea", Input, Textarea, SimpleSelect];

// 입력칸 위 작은 회색 라벨 — label 로 감싸고, 칸이 하나면 htmlFor·id 로도 이어 접근성 이름을 확실히 한다(안에 label·htmlFor 를 또 두지 않는다).
interface Props {
  label: ReactNode;
  children: ReactNode;
  className?: string;
}

const Field = ({ label, children, className }: Props) => {
  const autoId = useId();
  const control =
    isValidElement<{ id?: string }>(children) && LINKABLE.includes(children.type) ? children : null;
  const id = control ? (control.props.id ?? autoId) : undefined;
  return (
    <label className={cn("flex flex-col gap-y-1", className)} htmlFor={id}>
      <span className="text-xs text-muted-foreground">{label}</span>
      {control && control.props.id === undefined ? cloneElement(control, { id }) : children}
    </label>
  );
};

export default Field;
